export enum FeatureFlag {
  ABTestPlayingInsightsProfitLoss = 'abtest_playing_insights_profitloss',
  AMLLoginMsg = 'aml-login-msg',
  AMLLoginMsgVerified = 'aml-login-msg-verified',
  AccountChangeMobile = 'account_change_mobile',
  AccountCreatedContinue = 'AccountCreatedContinue',
  AccountMenuAddressSearch = 'acc-menu-address-search',
  Add2HomeScreen = 'a2hs',
  AddressUpdateDisabled = 'address-update-disabled',
  AllowSoftRedirectCancel = 'allow-soft-redirect-cancel',
  BankID = 'se-bankid-signup',
  BlackListCheck = 'blacklist-check',
  CapmodPlayerHandHistoryEnabled = 'capmod-player-hand-history-enabled',
  CasinoFavorites = 'CasinoFavorites',
  CasinoFreeSpinsToken = 'CasinoFreeSpinsToken',
  CasinoGameFeatureBonusFeatures = 'CasinoGameFeatureBonusFeatures',
  CasinoGameFeatureMaxBet = 'CasinoGameFeatureMaxBet',
  CasinoGameFeatureMinBet = 'CasinoGameFeatureMinBet',
  CasinoGameFeatureMultiplier = 'CasinoGameFeatureMultiplier',
  CasinoGameFeaturePaylines = 'CasinoGameFeaturePaylines',
  CasinoGameFeatureRTP = 'CasinoGameFeatureRTP',
  CasinoGameFeatureWilds = 'CasinoGameFeatureWilds',
  CasinoGameInfo = 'CasinoGameInfo',
  CasinoGameInfoDescription = 'CasinoGameInfoDescription',
  CasinoGameInfoDesktop = 'CasinoGameInfoDesktop',
  CasinoGameInfoMobile = 'CasinoGameInfoMobile',
  CasinoInstantBonusesToken = 'CasinoInstantBonusesToken',
  CasinoLimits = 'eCasinoLimits',
  CasinoLiveRacesTCReqd = 'CasinoLiveRacesTCReqd',
  CasinoLiveRoulette = 'CasinoLiveRouletteResultsFeed',
  CasinoNonAuth = 'eCasinoNonAuth',
  CasinoRewardsStoreToken = 'CasinoRewardsStoreToken',
  CasinoServiceInterruptionSplashPage = 'CasinoServiceInterruptionSplashPage',
  CasinoSlotRacesTCReqd = 'CasinoSlotRacesTCReqd',
  CasinoSpinOfDay = 'CasinoSpinOfTheDay',
  Chest = 'chestPageEnabled',
  CommlibProxy = 'CommlibProxy',
  CommunityForum = 'CommunityForumLinksInHeaderAndFooter',
  CowAddTokenAndSignatureToUrl = 'cow-add-token-and-signature-to-url',
  CrossOperatorInactiveStatus = 'CrossOperatorInactiveStatus',
  CustomPIN = 'custom-pin',
  DELossLimit = 'DE_losslimit',
  DEPanic = 'DE_Panic',
  DESpendLimit = 'DE_SpendLimit',
  DarkModeEnabled = 'dark_mode_enabled',
  DepositReverseCTAVerify = 'deposit-reverse-cta-verify',
  DisableBuenosAiresFeatures = 'DisableBuenosAiresFeatures',
  DisableNewUkAgeVerificationFlow = 'DisableNewUkAgeVerificationFlow',
  DisablePendingWithdrawalCancellation = 'swc-disable-pending-withdrawal-cancellation',
  DisableRam = 'DisableRam',
  DivertRAMToPoker = 'DivertRAMToPoker',
  DocumentsRequestPrompt = 'document_request_prompt',
  ESActivitySummaryReport = 'ES_ActivitySummaryReport',
  ESportsBookAuth = 'eSportsBookAuth',
  EnableBigWinningsGQLSubscription = 'EnableBigWinningsGQLSubscription',
  EnableESFixedDepositLimitValidity = 'EnableESFixedDepositLimitValidity',
  EnableNotificationServiceGQLSubscription = 'EnableNotificationServiceGQLSubscription',
  EnableOneTrust = 'enableOneTrust',
  EnablePostGeoRedirectModal = 'enablePostGeoRedirectModal',
  EnableSentry = 'enableSentry',
  EnableServerDepositLimitsDK = 'enableServerDepositLimitsDK',
  EnableTombolaContentCBSE = 'enableTombolaContentCBSE',
  EuDeOasisStreetAddress = 'EUDE_Oasis_Street_Address',
  FeedbackVerification = 'feedback-csat-verification',
  FixedPrizeDrawNotificationEnabled = 'FixedPrizeDrawNotificationEnabled',
  FooterDateTime = 'footer_date_time',
  ForceDefaultLocale = 'ForceDefaultLocale',
  FreeBets = 'freebets',
  FreeSpins = 'eFreeSpinsBonuses',
  Freemium = 'eFreemium',
  FreemiumMobile = 'eFreemiumMobile',
  GreyhoundRacingEnabled = 'ISP_GreyhoundRacingEnabled',
  HandHistoryRAMMyHandHistoryRequests = 'HandHistory_RAM_MyHandHistoryRequests',
  HideRsaTokenMenu = 'hideRsaTokenMenu',
  HideStarsPinMenu = 'hideStarsPinMenu',
  HorseRacingEnabled = 'ISP_HorseRacingEnabled',
  IDScanHosted = 'IDScan-Hosted',
  IDScanSDK = 'IDScan-SDK',
  ISPAmericanOdds = 'ISP_AmericanOdds',
  ISPAnimalRacingSpecials = 'ISP_Release_AnimalRacingSpecials',
  ISPBetBuilder = 'ISP_BetBuilder',
  ISPBetSlipCustomKeyboard = 'ISP_BetSlipCustomKeyboard',
  ISPBonusCash = 'ISP_BonusCash',
  ISPCashOut = 'ISP_CashOut',
  ISPDataVisualisation = 'ISP_DataVisualisation',
  ISPDynamicAlternates = 'ISP_DynamicAlternates',
  ISPEnableAddToBetSlipMyBets = 'ISP_Enable_AddToBetSlipMyBets',
  ISPEnableCorrectScoreTemplate = 'ISP_Enable_CorrectScoreTemplate',
  ISPEnableEnhancedBetTracking = 'ISP_Enable_EnhancedBetTracking',
  ISPEnableEventPagePopularBetBuilders = 'ISP_Enable_EventPagePopularBetBuilders',
  ISPEnableGlobalSportsSearch = 'ISP_Enable_GlobalSportsSearch',
  ISPEnableHomePagePopularAccumulators = 'ISP_Enable_HomePagePopularAccumulators',
  ISPEnableHomePagePopularBetBuilders = 'ISP_Enable_HomePagePopularBetBuilders',
  ISPEnableLandingPagePopularAccumulators = 'ISP_Enable_LandingPagePopularAccumulators',
  ISPEnableLandingPagePopularBetBuilders = 'ISP_Enable_LandingPagePopularBetBuilders',
  ISPEnableLiveAmericanFootballData = 'ISP_Enable_LiveAmericanFootballData',
  ISPEnableLiveBasketballData = 'ISP_Enable_LiveBasketballData',
  ISPEnableLiveData = 'ISP_Enable_LiveData',
  ISPEnableLiveESportsData = 'ISP_Enable_LiveESportsData',
  ISPEnableLiveFootballData = 'ISP_Enable_LiveFootballData',
  ISPEnableLiveIceHockeyData = 'ISP_Enable_LiveIceHockeyData',
  ISPEnableLiveStreaming = 'ISP_Enable_LiveStreaming',
  ISPEnableLiveTennisData = 'ISP_Enable_LiveTennisData',
  ISPEnableMobileStickyQuickLinks = 'ISP_Enable_MobileStickyQuickLinks',
  ISPEnableMyBetsDataVisualisation = 'ISP_Enable_MyBetsDataVisualisation',
  ISPEnableMyBetsLiveStreaming = 'ISP_Enable_MyBetsLiveStreaming',
  ISPEnablePromotionsQuickLink = 'ISP_Enable_PromotionsQuickLink',
  ISPEnableStarSub = 'ISP_Enable_StarSub',
  ISPExperimentPopularBetBuilderCount = 'ISP_Experiment_PopularBetBuilderCount',
  ISPHistoricalBets = 'ISP_HistoricalBets',
  ISPICEPromotions = 'ISP_ICE_Promotions',
  ISPMigrationBanner = 'ISP_Migration_Banner',
  ISPMyStarsFreeBets = 'Visibility_MyStars_FreeBets',
  ISPPromotionPicker = 'ISP_PromotionPicker',
  ISPPromotions = 'ISP_Promotions',
  ISPQuickSwitcher = 'ISP_QuickSwitcher',
  ISPReleaseEventPageWidget = 'ISP_Release_EventPageWidget',
  ISPReleasePssOddsBoostMarketTypeCodes = 'ISP_Release_PssOddsBoostMarketTypeCodes',
  ISPRouting = 'ISP_Routing',
  ISPScoreboards = 'ISP_Scoreboards',
  ISPSportsFreeBets = 'ISP_FreeBets',
  ISPStatusCheck = 'ISP_StatusCheck',
  Ice2Feature = 'ice2',
  IceFeature = 'eIceFeatureEnabled',
  IceLeaderboard = 'eIceLeaderBoard',
  IdpSecondaryLoginEnabled = 'idp-secondary-login-enabled',
  InstantBonusesVisibility = 'Visibility_MyStars_InstantBonuses',
  LiveChatSupport = 'eLiveChatSupport',
  LoginSEDialogue = 'loginSEDialogue',
  LoginSummaryNotificationModification = 'login-summary-notification-modification',
  LowBalancePrompt = 'wc2-balance-low-prompt',
  LoyaltyWidgetCasinoSports = 'pokerstars-rewards-casino-sports',
  LoyaltyWidgetRefresh = 'Loyalty_WidgetRefresh',
  LoyaltyWidgetService = 'Loyalty_WidgetService',
  MiniGameTickets = 'eMiniGameTickets',
  MktgMarketingCommunications = 'mktg-marketing-communications',
  MultiCurrency = 'multi-currency',
  NPS = 'SW-SimpleNPS',
  NPSPhase2 = 'SW-NPSPhase2',
  NoCasinoGameHistory = 'noCasinoGameHistory',
  NoLanguages = 'noLanguages',
  NoPokerStarsRewards = 'noPokerStarsRewards',
  PKRHomeGamesEmptyStateSideWall = '2023.Q1.Poker.HomeGames.RighSideBar.POKER-5484',
  PKRHomeGamesGameTilesUnsupported = '2022.Q2.Poker.HomeGames.GameTiles.WEB-10835',
  PKRHomeGamesJoinAndCreatePublicClubs = '2023.Q4.Poker.HomeGames.JoinAndCreatePublicClubs.POKER-9619',
  PKRHomeGamesLightMode = '2022.Q4.Poker.HomeGames.LightMode.POKER-2246',
  PKRHomeGamesLogInvalidSession = '2024.Q3.Poker.HomeGames.LogInvalidSession.POKER-14505',
  PKRHomeGamesNewSideBar = '2022.Q3.Poker.HomeGames.Sidebar.POKER-258',
  PKRHomeGamesOnboardingFirstTime = '2022.Q3.Poker.HomeGames.OBFirstTimeUX.POKER-378',
  PKRHomeGamesPublicClubSearch = '2023.Q1.Poker.HomeGames.BasicSearch.POKER-252',
  PKRHomeGamesPublicClubs = '2022.Q4.Poker.HomeGames.PublicClubs.POKER-1917',
  PKRHomeGamesTheWall = '2022.Q4.Poker.HomeGames.TheWall.POKER-1645',
  PKRHomeGamesVideoChatToggleRedesign = '2022.Q4.Poker.HomeGames.VideoChatToggleRedesign.POKER-2012',
  PKRMultiTableTournamentsMobileComingSoon = '2024.Q2.Poker.WebMTT.MobileComingSoon.POKER-11671',
  PKRMultiTableTournamentsVisibility = '2023.Q4.Poker.WebMTT.Visibility.POKER-8355',
  PKRNavigationActiveTableButton = '2024.Q2.Poker.Navigation.ActiveTableButton.POKER-12473',
  PKRPowerPathHideMoreTab = '2024.Q4.Poker.PowerPath.HideMoreTab.POKER-15554',
  PKRPowerPathHideOverviewPage = '2024.Q3.Poker.PowerPath.HideOverviewPage.POKER-13508',
  PKRPowerPathListViewToggle = '2024.Q3.Poker.PowerPath.ListViewToggle.POKER-13567',
  PKRRegulatoryAuthAgeVerification = '2025.Q1.Poker.WebRegulatory.AuthAgeVerification.POKER-16283',
  PKRSpinAndGoFlashAvailable = '2023.Q4.Poker.WebSAG.FlashAvailable.POKER-9938',
  PKRSpinAndGoHoldemAvailable = '2023.Q4.Poker.WebSAG.HoldemAvailable.POKER-9938',
  PKRSpinAndGoHoldemSixAvailable = '2024.Q4.Poker.WebSAG.HoldemSixAvailable.POKER-15188',
  PKRSpinAndGoMaxHoldemAvailable = '2023.Q4.Poker.WebSAG.MaxHoldemAvailable.POKER-8580',
  PKRSpinAndGoOmahaAvailable = '2023.Q4.Poker.WebSAG.OmahaAvailable.POKER-8580',
  PKRSpinAndGoWatchGamesVisibility = '2023.Q4.Poker.WebSAG.WatchGamesVisibility.POKER-7799',
  PRHub = 'PromoExp_PromotionsAndRewards',
  PRHubDesktopPopupOpen = 'PRHUB_popup',
  PSMessenger = 'PSMessenger',
  PSMessengerConfig = 'PSMessengerConfig',
  PSMessengerIgnoreLogin = 'PSMessengerIgnoreLogin',
  PSMessengerToggle = 'PSMessengerToggle',
  PlayMoney = 'playMoney',
  PmcPaywall = 'pmc-paywall',
  PublicLiveChatSupport = 'ePublicLiveChatSupport',
  RGLugasDepositLimit = 'RGLugasDepositLimit',
  ReleaseBonuses = 'ReleaseBonuses',
  RestrictSeWeeklyLimit = 'restrict-se-weekly-limit',
  RewardsStore = 'Visibility_MyStars_RewardsStore',
  RmfEmployerInfo = 'rmf-employer-info',
  SFConfig = 'SFConfig',
  SFHideLoginPrompt = 'SFHideLoginPrompt',
  SFShowButton = 'SFShowButton',
  SelfExclusionNewDesign = 'SelfExclusionNewDesign',
  SeparatedEulaPrivacyPolicy = 'separated_eula_privacy_policy',
  SessionPopupExtended = 'sessionPopupExtended',
  ShowJackpotWheel = 'Show-Jackpot-Wheel',
  ShowUKSpendBudgetMenu = 'ShowUKSpendBudgetMenu',
  SignUpShowState = 'SignUpShowState',
  SportsBonusCash = 'Visibility_MyStars_BonusCash',
  SportsBookLimits = 'eSportsBookLimits',
  SportsBookNonAuth = 'eSportsBookNonAuth',
  SportsBookOptions = 'eSportsBookOptions',
  SportsNonAuth = 'sports-non-auth',
  StrongAuthQuestionsPwdReset = 'strong-auth-questions-pwd-reset',
  SwcAccountHistoryNetDepositValues = 'ShowUKNetDepositValues',
  SwcAffiliateBonus = 'swc-affiliate-bonus',
  SwcCashier = 'swc-cashier',
  SwcCreditTime = 'swc-credit-time',
  SwcCurrencyManagementCes = 'swc-currency-management-ces',
  SwcDefaultCurrencyBlock = 'swc-default-currency-block',
  SwcDeposit = 'swc-deposit',
  SwcDepositCes = 'swc-deposit-ces',
  SwcDepositLimitButtonDisplay = 'swc-depositlimit-button-display',
  SwcDepositLimitCurrencyConversionInfo = 'swc-depositlimit-currency-conversion-info',
  SwcDepositMethodMinimum = 'swc-deposit-method-minimum',
  SwcDepositReloader = 'swc-deposit-reloader',
  SwcDispalyAutoConversionCTA = 'swc-display-autoconversion-cta',
  SwcECheckConfirmation = 'swc-eCheck-confirmation',
  SwcEmailVerification = 'swc-email-verification',
  SwcExitFlow = 'swc-exit-flow',
  SwcExploreCta = 'swc-explore-cta',
  SwcFetchVipPoints = 'swc-fetch-vip-points',
  SwcForceWithdrawal = 'swc-force-withdrawal',
  SwcHideFxInfo = 'swc-hide-fx-info',
  SwcLugasMessage = 'swc-lugas-message',
  SwcManageCurrencies = 'swc-manage-currencies',
  SwcManageDepositLimits = 'swc-manage-deposit-limits',
  SwcMethodVerificationDeposit = 'swc-method-verification-deposit',
  SwcMethodVerificationWithdraw = 'swc-method-verification-withdraw',
  SwcMethodsManagement = 'swc-methods-management',
  SwcNewCashierNotification = 'swc-new-cashier-notification',
  SwcNewSignupCountryImage = 'swc-new-signup-country-image',
  SwcOnboardingProgressbar = 'swc-onboarding-progressbar',
  SwcP2pCes = 'swc-p2p-ces',
  SwcP2pTransfer = 'swc-p2ptransfer',
  SwcPaypalSandboxQA = 'swc-paypal-sandbox-qa',
  SwcR2DWebFeatures = 'swc-r2d-web-features',
  SwcRMFPhoneVerification = 'swc-rmf-phone-verification',
  SwcReloaderBonus = 'swc-reloader-bonus',
  SwcRetryDOB = 'swc-retry-dob',
  SwcRetryFiscalCode = 'swc-retry-fiscalcode',
  SwcRetryPOB = 'swc-retry-pob',
  SwcRetryPhoneNumber = 'swc-retry-phonenumber',
  SwcRetrySSN = 'swc-retry-ssn',
  SwcRetryScreen = 'swc-retry-screen',
  SwcRmf = 'swc-rmf',
  SwcRmfAddressSearch = 'swc-rmf-address-search',
  SwcRmfBonusScreen = 'swc-rmf-bonus-screen',
  SwcRmfFeedbackCsat = 'swc-rmf-feedback-csat',
  SwcRmfNoLimits = 'swc-rmf-no-limits',
  SwcRmfShowOnlyWeeklyLimit = 'swc-rmf-show-only-weekly-limit',
  SwcSGScreen = 'swc-sg-screen',
  SwcSSN9 = 'swc-ssn9',
  SwcSignup = 'swc-signup',
  SwcSignupConsentPreferences = 'swc-signup-consentpreferences',
  SwcSignupDeposit = 'swc-signup-deposit',
  SwcSignupOnePage = 'swc-signup-onepage',
  SwcSignupPhoneCollection = 'swc-signup-phone-collection',
  SwcSignupRmf = 'swc-signup-rmf',
  SwcSignupRmfAutofocus = 'swc-signup-rmf-autofocus',
  SwcSignupRmfDefaultTransition = 'swc-signup-rmf-default-transition',
  SwcSignupRmfEcoEransitionTwo = 'swc-signup-rmf-ecotransitiontwo',
  SwcSignupRmfEcopokerLobby = 'swc_signup_rmf_ecopokerlobby',
  SwcSignupRmfSumSub = 'swc-signup-rmf-sumsub',
  SwcTransactionHistoryCes = 'swc-transaction-history-ces',
  SwcTransactionHistoryDownload = 'swc-transaction-history-download',
  SwcTransactionHistoryResults = 'swc-transaction-history-results',
  SwcTurorial = 'swc-tutorial',
  SwcWelcomeBonusScreen = 'swc-welcomebonus-screen',
  SwcWithdrawCes = 'swc-withdraw-ces',
  SwcWithdrawal = 'swc-withdrawal',
  SwcWithdrawalCreditTime = 'swc-withdrawal-credit-time',
  SwcWithdrawalMethodMinimum = 'swc-withdrawal-method-minimum',
  SwcXpayLibraryTestStatus = 'swc-xpay-library-test-status',
  TemporaryLoginTimeLimit = 'temporaryLoginTimeLimit',
  TheDeal = 'the-deal',
  TheDealHighRoller = 'the-deal-highroller',
  TwitchConnect = 'TwitchConnect',
  UseRam1 = 'UseRam1',
  UseWC2ResolverTags = 'useWC2ResolverTags',
  VegasPanicButtonDialogNewText = 'de-vegas-panic-button-dialog-new-text',
  VerificationRMOKCheck = 'docverify-check-rmok',
  VerifyAccount = 'verify-account',
  VerifyAccountAfterRmf = 'verify-account-after-rmf',
  VerifyAccountDrivingLicense = 'verify-account-driving-license',
  VerifyAccountNationalId = 'verify-account-national-id',
  VerifyAccountPassport = 'verify-account-passport',
  VerifyDoc = 'verify-doc',
  VerifyDocFallback = 'verify-doc-fallback',
  VerifyWCSF = 'verify-wcsf',
  VisibilityFeatureTab = 'Visibility_Feature_tab',
  VisibilityOASISExclusionOption = 'visibility_OASIS_exclusion_option',
  VisibilityPlayingInsights = 'Visibility_Playing_Insights',
  VisibilityPlayingInsightsLoginPopup = 'Visibility_Playing_Insights_Login_popup',
  VisibilityRestrictWithdrawalCancellation = 'visibility_restrict_withdrawal_cancellation',
  WPEnableWsDisconnectSentryReporting = 'wp-enable-ws-disconnect-sentry-reporting',
  WPKongFeatureSentryLog = 'WP-kong-feature-sentry-log',
  Wc2HidePlayMoneyButton = 'wc2-hide-play-money-button',
  Wc2PlayMoney = 'wc2-playmoney',
  WebMPCNotificationEnabled = 'WebMPCNotificationEnabled',
  WebNotificationEnabled = 'WebNotificationEnabled',
  WrmfAcAutotrigger = 'wrmf-ac-autotrigger',
  WrmfKBA = 'wrmf-kba'
}

export enum FeatureFlagParam {
  MinLtVpp = 'min-lt-vpp'
}
